import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { GeneralButton } from '../../../../CommonComponents/Commons/commonComponents';

const EditProfile = (props) => {
  return (
    <>
      {
        <GeneralButton
          width='100%'
          mobWidth='100%'
          type='primary'
          text='EDIT MY PROFILE'
          onClick={() => props.goToPage('/my-profile')}
          data-test='faEditProfileBtnClick'
        />
      }
    </>
  );
};

EditProfile.propTypes = {
  goToPage: PropTypes.func,
};

export default withRouter(EditProfile);
